export default class GlobalSettings {
    static usingSectorEnd() {
        return GlobalSettings.settings.sectorEnd && GlobalSettings.settings.sectorEnd != "unused";
    }
    static initFields() {
        GlobalSettings.numericFields = [
            { id: "unused", text: `Not used`, field: -1 },
            { id: "Number10", text: `Number10`, field: Office.ProjectTaskFields.Number10 },
            { id: "Number11", text: `Number11`, field: Office.ProjectTaskFields.Number11 },
            { id: "Number12", text: `Number12`, field: Office.ProjectTaskFields.Number12 },
            { id: "Number13", text: `Number13`, field: Office.ProjectTaskFields.Number13 },
            { id: "Number14", text: `Number14`, field: Office.ProjectTaskFields.Number14 },
            { id: "Number15", text: `Number15`, field: Office.ProjectTaskFields.Number15 },
        ];
    }
}
